import { apiFetch } from '../lib/api';
/**
 * Cancel a running background generation job.
 *
 * POST /api/jobs/:id/cancel marks the job 'cancelled' on the backend:
 * the processor aborts at its next step boundary, partial output is
 * discarded, the concurrency slot is freed immediately, and no
 * completion notification is created. Shared by the global progress
 * pill and every page-level in-progress card.
 */

export async function cancelGenerationJob(shop, jobId) {
  if (!jobId) return false;
  try {
    const res = await apiFetch(`/api/jobs/${jobId}/cancel`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ shop }),
    });
    return res.ok;
  } catch {
    return false;
  }
}
